module.exports = __webpack_public_path__ + "img/Wrap Icon - white.49251758.svg";